import React from "react";
import { useProductConfig, useProductContext } from "context/ProductContext";

interface MarketingGalleryProps {
    className?: string;
}

const MarketingGallery = ({ className = "" }: MarketingGalleryProps) => {
    const config = useProductConfig();
    const { isMLTA } = useProductContext();

    return (
        <div className={`relative h-96 max-h-80 max-w-lg mx-auto scale-80 tablet:scale-100 ${className}`}>
            <div className="absolute bottom-[-80px] left-[-120px] p-2 rounded transform w-[325px] z-[10] rotate-[-28deg] tablet:w-[300px] lg:w-[335px] tablet:top-[-100px] tablet:left-[-100px] tablet:bottom-0 tablet:rotate-2">
                <img src={config.assets.marketingGallery3} alt="Family 1" className="w-full object-cover rounded" />
            </div>

            <div
                className={`absolute bottom-[-10px] right-[-40px] p-2 rounded transform rotate-[-20deg] w-[280px] ${
                    isMLTA ? "z-[11]" : "z-[7] tablet:z-[8]"
                } tablet:top-[-60px] tablet:right-[-20px] tablet:w-[240px] lg:w-[270px] tablet:bottom-0 tablet:rotate-2`}
            >
                <img src={config.assets.marketingGallery2} alt="Family 2" className="w-full object-cover rounded" />
            </div>

            <div className="absolute bottom-[-0px] left-0 p-2 rounded transform rotate-[20deg] w-[290px] z-[9] tablet:z-[7] tablet:bottom-[-30px] lg:bottom-[-110px] tablet:left-[-70px] tablet:w-[280px] lg:w-[310px] tablet:rotate-2">
                <img src={config.assets.marketingGallery4} alt="Family 3" className="w-full object-cover rounded" />
            </div>

            <div className="absolute bottom-[30px] right-[-150px] p-2 rounded transform rotate-[20deg] w-[315px] z-[8] tablet:z-[9] tablet:bottom-[-30px] lg:bottom-[-120px] tablet:right-[-65px] tablet:w-[301px] lg:w-[336px] tablet:rotate-2">
                <img src={config.assets.marketingGallery1} alt="Family 4" className="w-full object-cover rounded" />
            </div>
        </div>
    );
};

export default MarketingGallery;
